function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M20.25 2.88965H8.25C7.95163 2.88965 7.66548 3.00817 7.4545 3.21915C7.24353 3.43013 7.125 3.71628 7.125 4.01465V7.38965H3.75C3.45163 7.38965 3.16548 7.50817 2.9545 7.71915C2.74353 7.93013 2.625 8.21628 2.625 8.51465V20.5146C2.625 20.813 2.74353 21.0992 2.9545 21.3101C3.16548 21.5211 3.45163 21.6396 3.75 21.6396H15.75C16.0484 21.6396 16.3345 21.5211 16.5455 21.3101C16.7565 21.0992 16.875 20.813 16.875 20.5146V17.1396H20.25C20.5484 17.1396 20.8345 17.0211 21.0455 16.8101C21.2565 16.5992 21.375 16.313 21.375 16.0146V4.01465C21.375 3.71628 21.2565 3.43013 21.0455 3.21915C20.8345 3.00817 20.5484 2.88965 20.25 2.88965ZM14.625 19.3896H4.875V9.63965H14.625V19.3896ZM19.125 14.8896H16.875V8.51465C16.875 8.21628 16.7565 7.93013 16.5455 7.71915C16.3345 7.50817 16.0484 7.38965 15.75 7.38965H9.375V5.13965H19.125V14.8896Z",
  fill: "#365DE6"
});
const SvgEventCopyBold = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEventCopyBold, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/event-copy-bold.b6ca0da1.svg";
export { ForwardRef as ReactComponent };